/**
 * Not used for Teens Footer anymore.
 * Scroll-to-top script lives inside the footer section Liquid file.
 */
/**
 * Teens Hero Banner — vertical fade slider ONLY
 * ------------------------------------------------
 * Selectors used by this file (unique to hero):
 *   [data-teens-hero-swiper]
 *   [data-teens-hero-pagination]
 *
 * theme.liquid (Swiper CDN already there):
 *   <script src="{{ 'hero-banner.js' | asset_url }}" defer></script>
 */
(function () {
    'use strict';
  
    var SELECTOR = '[data-teens-hero-swiper]';
    var instances = new WeakMap();
  
    function parseOptions(el) {
      try {
        return JSON.parse(el.getAttribute('data-teens-hero-swiper') || '{}');
      } catch (e) {
        return {};
      }
    }
  
    function buildConfig(el, opts) {
      var paginationEl = el.querySelector('[data-teens-hero-pagination]');
      var config = {
        direction: opts.direction || 'vertical',
        effect: opts.effect || 'fade',
        fadeEffect: { crossFade: true },
        speed: typeof opts.speed === 'number' ? opts.speed : 700,
        loop: !!opts.loop,
        watchOverflow: true,
        grabCursor: true,
        preventInteractionOnTransition: true,
        // Let page scroll continue on first/last slide (mobile touch + Windows trackpad)
        touchReleaseOnEdges: true,
        threshold: 5,
        resistanceRatio: 0,
        a11y: { enabled: true },
      };
  
      if (opts.mousewheel !== false) {
        config.mousewheel = {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        };
      }
  
      if (opts.autoplay) {
        config.autoplay = {
          delay: typeof opts.delay === 'number' ? opts.delay : 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }
  
      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }
  
      return config;
    }
  
    function initOne(el) {
      if (!el || el.getAttribute('data-swiper-ready') === 'true') return;
      if (typeof Swiper === 'undefined') return;
  
      var existing = instances.get(el);
      if (existing) {
        existing.destroy(true, true);
        instances.delete(el);
      }
  
      var swiper = new Swiper(el, buildConfig(el, parseOptions(el)));
      instances.set(el, swiper);
      el.setAttribute('data-swiper-ready', 'true');
    }
  
    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
  
      if (root && root.matches && root.matches(SELECTOR)) {
        initOne(root);
      }
  
      Array.prototype.forEach.call(nodes, initOne);
    }
  
    function destroyIn(root) {
      if (!root || !root.querySelectorAll) return;
      var nodes = root.querySelectorAll(SELECTOR);
      Array.prototype.forEach.call(nodes, function (el) {
        var swiper = instances.get(el);
        if (swiper) {
          swiper.destroy(true, true);
          instances.delete(el);
        }
        el.removeAttribute('data-swiper-ready');
      });
    }
  
    function boot() {
      initAll(document);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  
    document.addEventListener('shopify:section:unload', function (event) {
      destroyIn(event.target);
    });
  
    document.addEventListener('shopify:section:reorder', boot);
  })();
  